export type SalesFlyerProductSearch = {
	promoNumber: number;
	pageNumber?: number | null;
	keyword?: string;
}

export function getSalesFlyerPageProductListLink({
	promoNumber,
	pageNumber,
	keyword,
}: SalesFlyerProductSearch) {
	let path = `/sales-flyer/${promoNumber}/`;
	if (pageNumber != null) {
		path += `${pageNumber}/`;
	}

	const url = new URL(path, window.location.origin);

	if (keyword?.trim()) {
		url.searchParams.set('keyword', keyword);
	}

	return url.toString();
}